import { Avatar } from '@material-ui/core'
import styled, { keyframes } from 'styled-components/macro'

const pulseBlue = (shadow) => keyframes`
0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 ${shadow};
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
  }
`

export const AnimatedAvatar = styled(Avatar)`
:hover{
    box-shadow: 0 0 0 0 ${props => props.theme.colors.primary};
    animation: ${pulseBlue(props => props.theme.colors.primary)} 2s infinite;
}
`

export const StyledAvatar = styled(Avatar)`
box-shadow: 0 0 0 0 ${props => props.theme.colors.primary};
animation: ${pulseBlue(props => props.theme.colors.primary)} 2s infinite;
`

